import { useContext } from 'react';
import { StoreApi, UseBoundStore } from 'zustand';
import { useStoreWithEqualityFn } from 'zustand/traditional';

import { DollhouseRootState } from '../../store/index.js';

import { DollhouseContext } from './DollhouseContext.js';

export const useDollhouse = ((selector, equalityFn) => {
  const store = useContext(DollhouseContext);

  return useStoreWithEqualityFn(store, selector, equalityFn);
}) as UseBoundStore<StoreApi<DollhouseRootState>>;
